"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useInnerPageNav = () => {
  // Responsible for setting and holding the data for the inner-page nav
  const initialState = {
    breadcrumbs: [],
    siblings: []
  };
  const [innerPageNavData, setInnerPageNavData] = (0, _react.useState)(initialState);
  return {
    innerPageNavData,
    setInnerPageNavData
  };
};
var _default = useInnerPageNav;
exports.default = _default;